import { graphql } from '@/gql';
import type { GetTrialInfoFromLiveCallQuery } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export type TrialInfo = Extract<GetTrialInfoFromLiveCallQuery['getTrialInfoFromLiveCall'], {}>;

export const getTrialInfoFromLiveCall = async (): Promise<null | TrialInfo> => {
  const response = await queryExecute({
    fetchPolicy: 'network-only',
    query: graphql(`
      query getTrialInfoFromLiveCall {
        getTrialInfoFromLiveCall {
          periodCode
          isEligible
          isCurrent
          days
        }
      }
    `),
  });

  return response.data?.getTrialInfoFromLiveCall || null;
};
